module.exports = __webpack_public_path__ + "assets/img/1781589512665_.pic_hd.66e480f7.jpg";